import PtBrTranslation from './pt'
import EnUsTranslation from './en'
import SpanishTranslation from './es'

const translations = {
    'pt-BR': PtBrTranslation,
    'en-US': EnUsTranslation,
    'es': SpanishTranslation
}


export default translations